<template>
  <div class="wrap">
    <div class="use-template-button" v-if="supportTemplate">
      <el-button v-popover:popover type="link" icon="el-icon-menu" @click="goUseTemplate">使用属性模版填充</el-button>
    </div>
    <el-popover ref="popover" width="280" v-model="tipVisible" trigger="manual" placement="right-end">
      当前类目没有属性模版，请点击 <el-button type="text" @click="addOrEditTemplate">前往添加</el-button>
    </el-popover>
    <div class="warp-list" v-if="showTemplateList || total">
      <el-button style="color: #333" class="delete-btn" type="link" @click="hideTemplateList"> X </el-button>
      <div v-if="isCatePropsFromAi && list.length">
        <div>系统已通过AI预测类目属性，如信息正确可点击一键填充，如属性无法填充，请手动设置</div>
      </div>
      <div v-if="!isCatePropsFromAi && total">
        <span v-if="list.length"><strong>共 {{ list.length }} 个类目属性模版</strong>，请选择合适的模版进行一键填充</span>
        <el-input v-model="templateName" width="200px" placeholder="模版名称" @keyup.enter.native="search" class="mr_10"> </el-input>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="clear">重置</el-button>
      </div>
      <template v-if="list.length">
      <div v-for="(row, idx) in list" :key="row.id">
        <div class="templateName" v-if="row.templateName">模版名称： {{ row.templateName }}</div>
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div v-if="list.length > 1 && !detailHasCategory.length" style="width: 50px">{{ idx + 1 }}</div>
          <div style="width: 650px">
            <el-form :inline="true">
              <el-form-item style="width: 300px" v-for="prop in row.catPropList" :key="prop.key" :label="prop.key + ':'">
                <span style="font-size: 12px">{{ prop.value }}</span>
              </el-form-item>
            </el-form>
          </div>
          <div class="oprate-item">
            <el-button @click="addOrEditTemplate(row)" type="link" icon="el-icon-edit"></el-button>
            <el-button v-if="!isCatePropsFromAi" @click="deleteItem(row)" type="link" icon="el-icon-delete">删除</el-button>
            <el-tooltip v-if="isCatePropsFromAi && !refreshed" content="将排除该类目下常用类目属性值匹配，AI重新生成预测类目属性">
              <el-button @click="refreshPrediction(row)" type="link" icon="el-icon-refresh">刷新预测结果</el-button>
            </el-tooltip>
            <el-button @click="clickFill(row)" type="primary">一键填充</el-button>
          </div>
        </div>
      </div>
      </template>
      <div v-else style="text-align: center; padding: 15px;">暂无符合条件的模版</div>
    </div>
    <slot></slot>
    <div class="category-template-save-tip" v-if="showSaveCurCatPrposBtn">
      不想每次重复设置类目属性？快将类目属性保存为模版，下次一键填入
      <el-button type="primary" @click="saveCurCatPrpos" style="float: right">保存属性信息为模板</el-button>
    </div>
    <EditCategoryTemplateDialog ref="editCategoryTemplateDialogRef"></EditCategoryTemplateDialog>
  </div>
</template>
<script>
import EditCategoryTemplateDialog from '@components/prod/conf/components/CategoryPropTemplate/EditCategoryTemplateDialog.vue';

import { queryPlatformCatpropList, deletePlatformCatprop, predictionCatProps } from '@api/prod/conf/index.js';

import { cloneDeep } from 'lodash'

export default {
  inject: {
    openSource:{value:'openSource',default:null}
  },
  props: {
    supportTemplate: {
      type: Boolean,
      default: true,
    },
    supportAIPre: {
      type: Boolean,
      default: true,
    },
    platform: {
      type: String,
      default: '',
    },
    categoryIds: {
      type: Array,
      default() {
        return [];
      },
    },
    propValues: {
      type: Array | Object,
      default() {
        return [];
      },
    },
    baseItemId: {
      type: String,
      default: '',
    },
    shopId:{
      type: String | Number,
      default: ''
    },
    detailHasCategory:{
      type: Array,
      default() {
        return [];
      },
    },
    fxgCategoryPropertyPics:{ // 抖音类目属性图
      type: Object,
      default() {
        return {};
      },
    },
    getPropValues: Function,
  },
  components: {
    EditCategoryTemplateDialog,
  },
  data() {
    return {
      showTemplateList: false,
      templateName: '',
      list: [],
      total: 0,
      tipVisible: false,
      isCatePropsFromAi: false,
      refreshed: false,
    };
  },
  computed: {
    categoryId() {
      const categoryIds = this.categoryIds || [];
      return categoryIds[categoryIds.length - 1];
    },
    showSaveCurCatPrposBtn() {
      if(!this.supportTemplate) return false
      const propValues = this.getPropValues ? this.getPropValues() : this.propValues
      return this.categoryIds.length && propValues?.length
    },
  },
  watch: {
    categoryId() {
      if (!this.categoryId) return;
      this.list = [];
      this.showTemplateList = false
      this.refreshed = false
    },
    categoryIds: {
      handler(val) {
        if (!val || !val.length) return;
        if (this.supportAIPre) {
          if (!this.detailHasCategory || !this.detailHasCategory.length) {
            this.getCatePropsFromAi();
          }
        } else if (this.supportTemplate) {
          this.clear();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    goUseTemplate() {
      this.clear();
    },
    hideTemplateList() {
      this.showTemplateList = false
      this.total = 0
    },
    async getSearchData() {
      const platformType = this.platform === 'alibaba' ? '1688' : this.platform;
      const data = await queryPlatformCatpropList({
        platformType,
        categoryId: this.categoryId,
        templateName: this.templateName,
      });
      const list = data.records || [];
      list.forEach(item => {
        const propObjs = item.platformCatPropVoMap ? JSON.parse(item.platformCatPropVoMap) : {};
        item.catPropList = Object.keys(propObjs).map(key => ({ key, value: propObjs[key] }));
      });
      this.list = list.filter(item => item.catPropList.length);
      if(!this.templateName) {
        this.total = data.total || 0
        this.tipVisible = !this.list.length;
      }
      this.isCatePropsFromAi = false
      this.showTemplateList = !!this.list.length;
    },
    search() {
      this.getSearchData();
    },

    clear() {
      this.templateName = '';
      this.getSearchData();
    },
    saveCurCatPrpos() {
      const propValues = this.getPropValues ? this.getPropValues() : this.propValues
      let platformCatProp = JSON.stringify(propValues || [])
      let extendId1 = ''
      if(this.platform === 'fxg') {
        platformCatProp = cloneDeep(propValues)
        extendId1 = JSON.stringify(this.fxgCategoryPropertyPics || {})
      }
      this.addOrEditTemplate({
        platformCatProp,
        extendId1,
      }, false);
    },
    refreshPrediction() {
      this.getCatePropsFromAi({ refreshHistory: true })
      this.refreshed = true
    },
    addOrEditTemplate(row = {}, noUpdate) {
      this.tipVisible = false;
      this.$refs.editCategoryTemplateDialogRef.method_open({
        platform: this.platform,
        categoryIds: this.categoryIds,
        row,
        saveFn: () => {
          !noUpdate && this.clear();
        },
      });
    },
    async deleteItem(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await deletePlatformCatprop({ id: row.id });
        if (res) {
          this.$message.success('删除成功！');
          this.getSearchData();
        }
      });
    },
    clickFill(row) {
      this.$emit('clickFill', row);
    },

    async getCatePropsFromAi(extraParams){
      this.total = 0
      if(!this.categoryId || !this.baseItemId || this.openSource === 'shopGoods') return
      const platformType = this.platform === 'alibaba' ? '1688' : this.platform;
      const params = {
        baseItemId:this.baseItemId,
        platformType,
        catId:this.categoryId,
        shopId: this.shopId,
        ...extraParams
      }
      const res = await predictionCatProps(params)

      if(res && res.platformCatProp){
        const list = [res] || [];

        list.forEach(item => {
          const propObjs = item.platformCatPropVoMap ? JSON.parse(item.platformCatPropVoMap) : {};
          item.catPropList = Object.keys(propObjs).map(key => ({ key, value: propObjs[key] }));
        });
        this.list = list.filter(item => item.catPropList.length);
        this.isCatePropsFromAi = true
        this.showTemplateList = !!this.list.length;
      }
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  font-size: 12px;
  .warp-list {
    padding: 10px;
    // background-color: #e6e6df;
    background-color: #fdf6ec;
    position: relative;
    .delete-btn {
      position: absolute;
      right: 5px;
      top: 5px;
    }
    .oprate-item {
      .el-button {
        margin-left: 0;
      }
    }
  }
  .category-template-save-tip {
    width: 100%;
    margin-top: 10px;
    padding: 7px 8px 7px 16px;
    overflow-y: auto;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
  }
  .ml_10 {
    margin-left: 10px;
  }
  .mr_10 {
    margin-right: 10px;
  }
  .task-btns {
    margin: 10px 0;
  }
}
</style>
